import { Directive, ElementRef, HostListener, Input, OnInit } from '@angular/core';
import { FocusTarget } from 'shared/models/focus/focus.model';
import { MenuFocusHandlerDirective } from '../menu-focus-handler.directive';

@Directive({
  selector: '[appMenuFocusTarget]'
})
export class MenuFocusTargetDirective implements OnInit {
  @Input()
  focusTarget?: FocusTarget;
  @Input()
  focusHandler: MenuFocusHandlerDirective;

  constructor(public readonly elRef: ElementRef) {
  }

  ngOnInit(): void {
    if (!this.focusHandler) {
      throw new Error('Required input parameter "focusHandler" missing');
    }
  }

  focus(): void {
    const target = this.focusTarget || this.elRef.nativeElement;
    target.focus();
  }

  @HostListener('keydown.arrowDown', ['$event'])
  onSelectNext(ev: Event): void {
    ev.stopPropagation();
    ev.preventDefault();
    this.focusHandler.focusNextItem();
  }

  @HostListener('keydown.arrowUp', ['$event'])
  onSelectPrevious(ev: Event): void {
    ev.stopPropagation();
    ev.preventDefault();
    this.focusHandler.focusPreviousItem();
  }

  isFocusWithin(focusedElement: Element): boolean {
    return this.elRef.nativeElement.contains(focusedElement);
  }
}
